import { get, post, patch, del } from "@insite/client-framework/Services/ApiService";

export interface AddOrUpdateBranchApiModel {
    id?: string;
    name: string;
    addressLine1: string;
    addressLine2?: string;
    city: string;
    state: string;
    zipCode: string;
}

export interface BranchModel {
    id: string;
    name: string;
    addressLine1: string;
    addressLine2?: string;
    city: string;
    state: string;
    zipCode: string;
}

export interface BranchCollectionModel {
    branchModels: BranchModel[];
    pagination?: {
        currentPage: number;
        page: number;
        pageSize: number;
        totalItemCount: number;
        numberOfPages: number;
    };
}

export interface DeleteBranchModel {
    id: string;
    success: boolean;
}

const baseUrl = "/api/v2/centroconnect/sme/admin/branch";
// const collectionUrl = `${baseUrl}?page=1&pageSize=50`;

export function addBranch(model: AddOrUpdateBranchApiModel) {
    return post<AddOrUpdateBranchApiModel, BranchModel>(baseUrl, model as any);
}

export function getBranchCollection(page?: number, pageSize?: number, query?: string) {
    const params = new URLSearchParams();
    if (page !== undefined) {
        params.append('page', page.toString());
    }
    if (pageSize !== undefined) {
        params.append('pageSize', pageSize.toString());
    }
    if (query !== undefined) {
        params.append('query', query.trim());
    }
    const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
    return get<BranchCollectionModel>(url);
}

export function updateBranch(model: AddOrUpdateBranchApiModel) {
    return patch<any>(baseUrl, model as any) as Promise<BranchModel>;
}

export function deleteBranch(branchId: string) {
    return del(`${baseUrl}/${branchId}`) as Promise<void>;
}
export const getBranchById = async (branchId: string): Promise<any> => {
    return get<BranchModel>(`${baseUrl}/${branchId}`);
};
